"use strict";
export const GridMock = (mock) => {
  mock.onGet("/api/v7/departments").reply((config) => {
    let response = {
      "model": "department.tree",
      "count": 48,
      "id": "org_oe2c8f1fae2e542e08ccfb13b1e3d848f",
      "label": "13672021479\u56E2\u961F",
      "user_names": [
        "\u7BA1\u7406\u5458"
      ],
      "parent_id": null,
      "children": [
        {
          "model": "department.tree",
          "count": 0,
          "id": "department_7ffdfabea6b04e2f890002fc41ddf6ed",
          "label": "qwe123",
          "user_names": [],
          "parent_id": "org_oe2c8f1fae2e542e08ccfb13b1e3d848f",
          "children": [
            {
              "model": "department.tree",
              "count": 2,
              "id": "department_edff6a1c98534519a74b706967f05d09",
              "label": "22wew5e4ew4e",
              "user_names": [
                "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641"
              ],
              "parent_id": "department_7ffdfabea6b04e2f890002fc41ddf6ed",
              "children": []
            }
          ]
        },
        {
          "model": "department.tree",
          "count": 0,
          "id": "department_b3a12f2abd474dfba912c3ae6df462e7",
          "label": "12345678",
          "user_names": [],
          "parent_id": "org_oe2c8f1fae2e542e08ccfb13b1e3d848f",
          "children": [
            {
              "model": "department.tree",
              "count": 8,
              "id": "department_8d9f65a9c579402989c811bcc8915d0b",
              "label": "\u6D4B\u8BD5\u90E8\u95E83",
              "user_names": [
                "\u5458\u5DE5783216520321650531525621563152152153621562326152",
                "\u738B\u6668"
              ],
              "parent_id": "department_b3a12f2abd474dfba912c3ae6df462e7",
              "children": []
            }
          ]
        }
      ]
    };
    return [200, response];
  });
};
